package fr.labodoc.healthProfessional.webApp.data.repository

import arrow.core.Either
import fr.labodoc.healthProfessional.webApp.data.error.RepositoryError
import fr.labodoc.healthProfessional.webApp.data.model.MedicalDiplomaModel
import fr.labodoc.healthProfessional.webApp.data.source.remote.MedicalDiplomasRemoteDataSource

class MedicalDiplomasRepositoryImpl(
  private val medicalDiplomasRemoteDataSource: MedicalDiplomasRemoteDataSource
) : MedicalDiplomasRepository {
  override suspend fun getMedicalDiplomas(
    forHealthDirectoryProfessionCode: String?
  ): Either<RepositoryError.DataSource, Set<MedicalDiplomaModel>> =
    medicalDiplomasRemoteDataSource
      .getMedicalDiplomas(
        forHealthDirectoryProfessionCode = forHealthDirectoryProfessionCode
      )
      .mapLeft(RepositoryError::DataSource)
}
